var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"goTop"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.goTopShow),expression:"goTopShow"}],staticClass:"goTop",on:{"click":_vm.goTop}},[_c('div',[_vm._v("回到顶部")])])])}
var staticRenderFns = []

export { render, staticRenderFns }